import { GridColDef, GridRowsProp } from '@mui/x-data-grid-pro';

import { EditRemoveBtn } from 'components/buttons';
import { PanelGrid } from 'components/grid';
import { Block } from 'components/page';
import { useQueryCluster } from 'pages/complementar/cluster/hooks';
import { Cluster } from 'pages/complementar/cluster/types';

/**
 * Retorna as linhas da grid.
 */
const getRows = (data?: Cluster[]): GridRowsProp => {
    if (Array.isArray(data) && data.length) {
        return data.map((item) => ({
            id: item.idClusterLoja,
            dsClusterLoja: item.dsClusterLoja,
            cdClusterLoja: item.cdClusterLoja,
            fgAtivo: item.fgAtivo,
        }));
    }

    return [];
};

const columns: GridColDef[] = [
    { field: 'cdClusterLoja', headerName: 'Código', flex: 1, minWidth: 100, type: 'string' },
    { field: 'dsClusterLoja', headerName: 'Descrição', width: 160, type: 'string' },
    { field: 'fgAtivo', headerName: 'Ativo', width: 80, type: 'boolean' },
    {
        field: 'acoes',
        align: 'center',
        headerAlign: 'center',
        headerName: 'Ações',
        filterable: false,
        sortable: false,
        hideable: false,
        disableColumnMenu: true,
        width: 110,
        renderCell: ({ row }) => <EditRemoveBtn id={row.id} showEditBtn={true} sx={{ ml: 'auto', p: 1.5 }} />,
    },
];

export function ClusterGrid() {
    const { refetch, data, isFetching } = useQueryCluster();

    return (
        <Block>
            <PanelGrid rows={getRows(data?.data)} rowsCount={data?.total ?? 0} reload={refetch} loading={isFetching} columns={columns} />
        </Block>
    );
}
